/**
 * GERADO AUTOMATICAMENTE pelo workflow sync-release-changelog.yml
 * NÃO edite manualmente — edite o body da GitHub Release em:
 * https://github.com/suporte-adtecnologia/ad-tickets/releases
 *
 * Tipos de item: "new" | "improvement" | "fix" | "breaking"
 */

export const CURRENT_VERSION = "1.27.0";

export const RELEASES = [
  {
    version: "1.27.0",
    date: "2026-10-16",
    title: "Visibilidade por setor e canal",
    highlight: "Visibilidade de tickets passa a seguir os setores e canais vinculados a cada atendente, inclusive em tickets fechados. Atribuição e criação de tickets também respeitam essa regra.",
    items: [
      {
        type: "new",
        text: "Atribuição de ticket (transferência, participante e criação com dono) só para atendentes que enxergam o ticket no destino (setor e canal).",
      },
      {
        type: "new",
        text: "Modal de transferência lista apenas atendentes elegíveis, com busca no servidor.",
      },
      {
        type: "new",
        text: "Endpoint  com os atendentes elegíveis para o destino.",
      },
      {
        type: "new",
        text: "Filtro de canais do atendente mostra apenas os canais vinculados a ele.",
      },
      {
        type: "new",
        text: "Ticket nasce no único setor do canal.",
      },
      {
        type: "new",
        text: "Endpoint  para enviar mensagem sem criar ticket.",
      },
      {
        type: "new",
        text: "Soft delete de canais, preservando o  dos tickets.",
      },
      {
        type: "new",
        text: "Filtro de período nos cards de mensagens enviadas e recebidas do dashboard.",
      },
      {
        type: "improvement",
        text: "Filtros de setor e canal da interface são sempre restritos ao escopo do usuário; Mostrar todos não amplia o escopo de atendentes.",
      },
      {
        type: "improvement",
        text: "Contadores de tickets são calculados por usuário, com o mesmo escopo da listagem.",
      },
      {
        type: "improvement",
        text: "Eventos de ticket, mensagens e enquetes em tempo real só chegam a quem tem acesso ao ticket.",
      },
      {
        type: "fix",
        text: "Tickets de outros setores e canais apareciam na lista após a reconexão ao socket.",
      },
      {
        type: "fix",
        text: "Pill do canal ficava cinza após a sincronização de tickets pelo socket.",
      },
      {
        type: "fix",
        text: "Pill do setor ficava cinza para tickets fora do escopo do usuário.",
      },
      {
        type: "fix",
        text: "Socket permitia entrar na sala de um ticket sem acesso.",
      },
      {
        type: "fix",
        text: "Logs de QR de conexão Baileys não lidos entravam em loop.",
      },
      {
        type: "fix",
        text: "Migration de  em Whatsapps não era idempotente.",
      },
      {
        type: "fix",
        text: "Endpoint  retornava 500 para origem não permitida por CORS.",
      },
      {
        type: "fix",
        text: "Mensagens enviadas entre canais internos não eram gravadas.",
      },
      {
        type: "breaking",
        text: "Atendentes e supervisores deixam de ver tickets sem setor vinculado, inclusive os que abriram ou que estão atribuídos a eles, quando o setor do ticket não está vinculado ao usuário.",
      },
      {
        type: "breaking",
        text: "Criação de ticket por atendente exige setor e canal vinculados ao próprio usuário; atribuição a outro usuário sem acesso ao ticket é recusada.",
      },
    ],
  },
  {
    version: "1.26.1",
    date: "2026-10-02",
    title: "Estabilidade no recebimento de mensagens e mídias",
    highlight: "Correções de estabilidade no recebimento de mensagens e mídias: imagens e áudios voltam a ser salvos corretamente, e atendentes com conexão instável deixam de perder mensagens novas na conversa.",
    items: [
      {
        type: "improvement",
        text: "Ao reconectar, a conversa aberta ressincroniza as mensagens com o servidor, sem precisar recarregar a página.",
      },
      {
        type: "improvement",
        text: "O histórico de conversas em grupo carrega 50 mensagens por página e busca a próxima página automaticamente quando o conteúdo não preenche a tela, evitando trechos de ticket cortados.",
      },
      {
        type: "improvement",
        text: "Falhas no download de mídia do WhatsApp passam a ter novas tentativas automáticas; se ainda assim falhar, a mensagem é registrada com um aviso em vez de ser descartada.",
      },
      {
        type: "improvement",
        text: "Registro de desconexões do socket mais detalhado (motivo, usuário e ticket), facilitando investigar quedas de conexão.",
      },
      {
        type: "fix",
        text: "Corrige imagens e áudios recebidos que deixaram de ser salvos após a atualização do WhatsApp Web.",
      },
      {
        type: "fix",
        text: "Corrige atendentes que ficavam sem ver mensagens novas após quedas de conexão.",
      },
      {
        type: "fix",
        text: "Corrige o carregamento de mensagens de reserva (polling), que era afetado por eventos de outros tickets.",
      },
      {
        type: "fix",
        text: "Corrige a paginação do histórico, que podia pular páginas em rolagens seguidas.",
      },
    ],
  },
  {
    version: "1.26.0",
    date: "2026-09-25",
    title: "Finalizar sem atendimento e transcrição de chamados GLPI",
    highlight: "Ticket sem valor de atendimento (número desconhecido, engano, spam) agora tem um caminho próprio para ser encerrado, sem abrir brecha para pular o registro de um atendimento real. Chamados GLPI também passam a trazer a transcrição completa da conversa, com mídia de verdade.",
    items: [
      {
        type: "new",
        text: "Novo botão Finalizar sem atendimento na lista de tickets, para casos sem trâmite, tarefa ou chamado GLPI (número desconhecido, mensagem por engano, spam). Exige um motivo em texto livre, registrado no histórico do ticket.",
      },
      {
        type: "new",
        text: "O botão da conversa foi renomeado para Finalizar com atendimento, mantendo o fluxo completo (incluindo abertura de chamado GLPI).",
      },
      {
        type: "new",
        text: "Chamados GLPI passam a incluir a transcrição da conversa em balões, no estilo WhatsApp, com imagem, áudio e vídeo reais em vez de apenas o link do arquivo.",
      },
      {
        type: "new",
        text: "Vínculo entre o atendente do sistema e o usuário do GLPI, com um fallback mais estável quando esse vínculo não existe.",
      },
      {
        type: "improvement",
        text: "A decisão de abrir o fluxo GLPI ao encerrar ou devolver um ticket agora usa sempre os dados mais recentes do ticket, evitando que o botão da lista e o da conversa se comportem de forma diferente para o mesmo ticket.",
      },
      {
        type: "improvement",
        text: "O comando  não fecha mais um ticket que precisa passar pelo chamado GLPI.",
      },
      {
        type: "fix",
        text: "Corrige duplicação do texto da solução na tarefa de apontamento de horas do GLPI.",
      },
      {
        type: "fix",
        text: "Corrige o autor registrado no chamado GLPI, evitando registrar a solução antes da tarefa correspondente.",
      },
      {
        type: "fix",
        text: "Corrige duplicação de remetente e identificação de participante de grupo na transcrição.",
      },
      {
        type: "fix",
        text: "Corrige o flicker do favicon ao carregar a página.",
      },
    ],
  },
  {
    version: "1.25.0",
    date: "2026-09-18",
    title: "GLPI: painel de encerramento e apontamento de tarefas",
    highlight: "Painel de encerramento do GLPI ganha layout de painel lateral com apontamento granular de tarefas, a API pública passa a suportar WABA/Meta e Baileys, e o envio de mídia/documento no WhatsApp volta a funcionar após quebra causada por atualização do WhatsApp Web.",
    items: [
      {
        type: "new",
        text: "Painel de encerramento de chamados GLPI agora abre como painel lateral (drawer), com apontamento granular de tarefas sincronizado automaticamente como tarefa do ticket.",
      },
      {
        type: "new",
        text: "API pública passa a suportar envio de mensagens pelos canais oficiais (WABA/Meta Cloud API) e Baileys, incluindo templates da Meta.",
      },
      {
        type: "new",
        text: "Tarefas registradas agora exibem o atendente responsável e encadeiam o período de apontamento por atendente.",
      },
      {
        type: "new",
        text: "Nova opção em Configurações para ocultar o conteúdo de mensagens apagadas no WhatsApp, mantendo apenas o aviso de mensagem apagada — reflete o comportamento real do WhatsApp (desativado por padrão = conteúdo oculto).",
      },
      {
        type: "improvement",
        text: "Transição do painel de encerramento do GLPI alinhada com a do painel de contato, para uma experiência mais consistente.",
      },
      {
        type: "fix",
        text: "Corrigido erro que impedia o envio de mídia e documentos pelo WhatsApp (canal QR/whatsapp-web.js), causado por mudança recente do WhatsApp Web.",
      },
      {
        type: "fix",
        text: "Corrigido crash ao rolar a lista de atendentes até o fim.",
      },
      {
        type: "fix",
        text: "Corrigido nome do chamado GLPI (mantém prefixo do ticket, remove setor do título padrão) e permite nome opcional do chamado.",
      },
      {
        type: "fix",
        text: "Corrigido deslocamento do painel de encerramento do GLPI.",
      },
      {
        type: "fix",
        text: "Corrigida corrida entre tempo decorrido do aceite e soma de atividades no GLPI.",
      },
      {
        type: "fix",
        text: "Corrigido crash no login quando os campos de início/fim de expediente estavam vazios.",
      },
      {
        type: "fix",
        text: "Corrigida leitura de permissões de token de API.",
      },
      {
        type: "fix",
        text: "Corrigido escopo do evento de reação de mensagem, evitando emissão para o ticket errado.",
      },
    ],
  },
  {
    version: "1.24.1",
    date: "2026-09-04",
    title: "Versão 1.24.1",
    highlight: "Correções importantes no atendimento, com destaque para o canal WhatsApp via Baileys.",
    items: [
      {
        type: "fix",
        text: "**WhatsApp (Baileys):** mensagens enviadas pelo atendente agora chegam corretamente ao contato/grupo — antes ficavam travadas (relóginho) ou, quando enviadas manualmente por fora, apareciam no sistema como se fossem do próprio contato, sem a assinatura do atendente.",
      },
      {
        type: "fix",
        text: "**WhatsApp (Baileys):** nome de grupos não é mais sobrescrito pelo nome pessoal de quem manda a última mensagem.",
      },
      {
        type: "fix",
        text: "Tickets sem fila voltam a aparecer corretamente na lista, sendo classificados automaticamente em Sem Departamento até o atendente definir a fila certa.",
      },
      {
        type: "fix",
        text: "Menu de escolha de setor do chatbot (WhatsApp Web) voltou a funcionar para contatos novos.",
      },
      {
        type: "fix",
        text: "**Telegram:** modal de configuração passa a pedir mensagem de saudação/despedida quando há mais de uma fila, evitando erro ao salvar.",
      },
    ],
  },
  {
    version: "1.24.0",
    date: "2026-09-03",
    title: "Canal Telegram nativo e canal WhatsApp via Baileys",
    highlight: "Dois novos canais de mensageria — Telegram (bot próprio) e WhatsApp via Baileys — além de correções de estabilidade em conexões e tickets.",
    items: [
      {
        type: "new",
        text: "Novo canal Telegram: conecte um bot próprio (criado no @BotFather) diretamente na Bot API do Telegram, sem depender de integradores externos",
      },
      {
        type: "new",
        text: "Novo canal WhatsApp via Baileys: conexão direta alternativa ao WhatsApp Web tradicional",
      },
      {
        type: "fix",
        text: "Corrige falha de carregamento de tickets causada por tipo de dado não declarado explicitamente na fila do ticket",
      },
      {
        type: "fix",
        text: "Corrige edição de canal Baileys que acabava criando um novo canal em vez de atualizar o existente",
      },
      {
        type: "fix",
        text: "Corrige migração de canal que ignorava o status da sessão de destino e a membresia em grupos",
      },
      {
        type: "fix",
        text: "Corrige reprocessamento indevido de mensagens antigas após reconexão do WhatsApp",
      },
      {
        type: "fix",
        text: "Remove a atribuição forçada de setor padrão ao criar tickets, permitindo que o chatbot decida o setor quando aplicável",
      },
    ],
  },
  {
    version: "1.23.0",
    date: "2026-09-03",
    title: "WhatsLab e correções de estabilidade",
    highlight: "Correções de estabilidade em conexões WhatsApp e no fluxo de tickets, além do novo ambiente de laboratório para testar conexões (WhatsLab).",
    items: [
      {
        type: "new",
        text: "WhatsLab: novo ambiente de laboratório para testar conexões WhatsApp isoladamente",
      },
      {
        type: "new",
        text: "Número do ticket agora aparece no toast de erro, facilitando o diagnóstico",
      },
      {
        type: "fix",
        text: "Mensagens de tipo desconhecido (ex: figurinhas antigas, cartões de contato) deixam de gerar ticket indevidamente",
      },
      {
        type: "fix",
        text: "Correção na resolução da fila (queueId) ao criar ticket a partir de evento de grupo",
      },
      {
        type: "fix",
        text: "Correção no formato de data e fuso horário no envio de chamados para o GLPI",
      },
      {
        type: "fix",
        text: "Corrigido loop infinito de requisições em /personalizations",
      },
    ],
  },
  {
    version: "1.22.0",
    date: "2026-08-26",
    title: "Correções de estabilidade em WhatsApp e GLPI",
    highlight: "Correções de estabilidade no envio de mídia e mensagens do WhatsApp e no fuso horário dos chamados GLPI.",
    items: [
      {
        type: "improvement",
        text: "Log de erros do GLPI agora mostra o motivo real retornado pela API em vez de apenas o status HTTP, facilitando o diagnóstico",
      },
      {
        type: "improvement",
        text: "Log de erro ao enviar mensagem para grupo do WhatsApp agora mostra a mensagem/stack real do erro em vez de [object Object]",
      },
      {
        type: "fix",
        text: "Corrige timezone incorreto (America/Cuiaba em vez de America/Sao_Paulo) no envio de horários ao GLPI, que causava defasagem de 1h nos registros dos chamados",
      },
      {
        type: "fix",
        text: "Corrige mídia enviada sendo apagada indevidamente quando o redownload do WhatsApp falha, fazendo a imagem/arquivo sumir do histórico do ticket",
      },
      {
        type: "fix",
        text: "Corrige possível duplicação de usuário no GLPI quando o login armazenado diverge levemente do informado na busca",
      },
    ],
  },
  {
    version: "1.21.0",
    date: "2026-08-13",
    title: "Segmentação de tickets por setor e abertura de chamado GLPI ao devolver para fila",
    highlight: "Segmentação de tickets por setor unificada e abertura de chamado GLPI ao devolver ticket para fila, além de correções de estabilidade em WhatsApp, e-mail, GLPI e menções.",
    items: [
      {
        type: "new",
        text: "Visibilidade de tickets unificada em torno do vínculo de setor (UserQueues) como fonte única de verdade, alinhando REST, contadores e tempo real; corrige tickets pendentes invisíveis para admin sem vínculo na fila e amplia o alcance do supervisor para ver tickets de outros atendentes nos setores dele",
      },
      {
        type: "new",
        text: "Ao devolver um ticket para a fila com GLPI habilitado, agora é possível abrir um chamado GLPI (que permanece aberto), registrando uma nota interna com o atendente e o número do chamado",
      },
      {
        type: "improvement",
        text: "Retry automático para erros de rede puros e timeout na instância do axios, aumentando a resiliência de chamadas à API",
      },
      {
        type: "improvement",
        text: "Texto de confirmação ao fechar chamados maiores que o parâmetro do sistema ajustado",
      },
      {
        type: "fix",
        text: "Loop de reconexão infinito no socket quando o token JWT expira",
      },
      {
        type: "fix",
        text: "Observação digitada pelo atendente ao devolver ticket para fila agora é incluída na nota do chamado GLPI aberto",
      },
      {
        type: "fix",
        text: "resolveBodyMentions aplicado corretamente em mensagens citadas e álbuns",
      },
      {
        type: "fix",
        text: "Comando //transferir passa a expor o erro real em vez de mensagem genérica",
      },
      {
        type: "fix",
        text: "Campos Tipo/Categoria/Classificação ocultados ao adicionar a um chamado GLPI já existente",
      },
      {
        type: "fix",
        text: "Assinatura duplicada ao editar mensagem removida",
      },
      {
        type: "fix",
        text: "Erro real de envio de e-mail exposto no adticket-error.log",
      },
      {
        type: "fix",
        text: "Telefone digitado manualmente não é mais substituído pelo LID ao criar contato",
      },
      {
        type: "fix",
        text: "Gap do restart manual/FORCE_RESTART que não limpava o timer órfão do watchdog, corrigido",
      },
    ],
  },
  {
    version: "1.20.3",
    date: "2026-08-06",
    title: "Estabilidade de sessões WhatsApp: backport de fixes do wwebjs e correção de loop de restart",
    highlight: "Correções de estabilidade nas sessões do WhatsApp (wwebjs): adianta duas correções ainda não lançadas oficialmente e elimina um vazamento de watchdog que causava loop de reinício.",
    items: [
      {
        type: "fix",
        text: "Backport de duas correções do repositório oficial do  (ainda não publicadas em nenhuma versão): refatoração da extração do auth store e correção de eventos  duplicados após reinjeção da sessão",
      },
      {
        type: "fix",
        text: "Sessão presa em  podia entrar em loop de reinício a cada ~5min: um watchdog órfão (nunca removido de  em restarts automáticos) disparava sozinho contra uma sessão já substituída",
      },
    ],
  },
  {
    version: "1.20.2",
    date: "2026-08-06",
    title: "Correção de reações do WhatsApp (@lid) e contagem de abas",
    highlight: "Correções pontuais no tratamento de reações do WhatsApp (@lid) e na contagem de abas de tickets.",
    items: [
      {
        type: "fix",
        text: "Reações do WhatsApp (emojis) com `@lid` deixavam de trazer `id`/`msgId` corretamente após a mudança do WhatsApp Web que passou a expor `$1` em vez de `_serialized`; o patch local do `whatsapp-web.js` agora normaliza também as chaves de reação",
      },
      {
        type: "fix",
        text: "Contagem das abas de tickets alinhada com a permissão real do atendente",
      },
    ],
  },
  {
    version: "1.20.1",
    date: "2026-08-04",
    title: "Correção do botão Atualizar e diagnóstico de sendSeen",
    highlight: "Correções pontuais no contador de tickets e melhoria de diagnóstico em falha de confirmação de leitura no WhatsApp.",
    items: [
      {
        type: "fix",
        text: "Botão Atualizar da tela de tickets não força mais a volta para a aba Aberto ao ser clicado em outra aba (Aguardando/Fechados/Grupos)",
      },
      {
        type: "improvement",
        text: "Log de erro do  (duplo-check) em  agora traz chatId, ticketId, whatsappId e stack trace completo, para diagnosticar a falha recorrente concentrada no canal de maior volume",
      },
    ],
  },
  {
    version: "1.20.0",
    date: "2026-08-04",
    title: "Atendentes por canal, virada de dia configurável e estabilidade do WhatsApp",
    highlight: "Atendentes visíveis por canal com alerta de canal sem cobertura, virada de dia configurável e correções de estabilidade nas sessões do WhatsApp.",
    items: [
      {
        type: "new",
        text: "Tela de Canais passa a exibir quantos atendentes estão atribuídos a cada canal (n/N) e alerta admins/masteradmins quando um canal fica sem nenhum atendente",
      },
      {
        type: "new",
        text: "Virada de dia (tickets abertos → aguardando) agora é configurável em Configurações > Gerais > Gerenciamento de Tickets, podendo ser desabilitada",
      },
      {
        type: "improvement",
        text: "Health-check periódico das sessões WhatsApp após ficarem prontas (READY), detectando sessões zumbis que travam sem avisar e reiniciando-as automaticamente",
      },
      {
        type: "fix",
        text: "Sessão do WhatsApp (wwebjs) podia travar em AUTHENTICATED após restart do PM2, por locks órfãos do LevelDB",
      },
      {
        type: "fix",
        text: "Balões de contagem nas abas de tickets divergiam da contagem real da lista",
      },
      {
        type: "fix",
        text: "Botão de reportar problema reposicionado para a AppBar",
      },
      {
        type: "fix",
        text: "Badge de atendentes por canal zerava ao vivo em eventos de socket (create/update/restart/validate-token) antes do próximo reload da página",
      },
    ],
  },
  {
    version: "1.19.3",
    date: "2026-07-28",
    title: "Correção de requerente no GLPI e estabilidade do backend",
    highlight: "Correções de estabilidade no backend e na integração com o GLPI: chamados que ficavam sem usuário atribuído por erro 400 na criação do requerente agora são resolvidos corretamente.",
    items: [
      {
        type: "fix",
        text: "Corrigida a criação/vinculação de requerente no GLPI: a busca por login/e-mail usava , que nunca funciona para o campo de login (tipo ), fazendo o sistema tentar recriar usuários já existentes e falhar com erro 400. Também foram corrigidos ~190 chamados já abertos que haviam ficado sem requerente por essa causa (issues #99, #100, #101).",
      },
      {
        type: "fix",
        text: "Logs de erro da integração GLPI agora expõem o corpo real da resposta da API em vez de , facilitando o diagnóstico de falhas.",
      },
      {
        type: "fix",
        text: "Mensagens do tipo interactive de contatos identificados por  agora são tratadas corretamente.",
      },
      {
        type: "fix",
        text: "Corrigida rejeição não tratada () na inicialização da sessão do WhatsApp (), que podia derrubar o processo.",
      },
      {
        type: "fix",
        text: "Corrigido loop de refresh de token concorrente que gerava chamadas repetidas ao endpoint de error-logs.",
      },
    ],
  },
  {
    version: "1.19.2",
    date: "2026-07-27",
    title: "Versão 1.19.2",
    highlight: "Correção de bugs na reconexão automática de canais do WhatsApp, evitando reinícios desnecessários e processos do Chrome órfãos no servidor.",
    items: [
      {
        type: "fix",
        text: "Watchdogs de reconexão automática (sessão presa em  ou ) agora revalidam o status atual da sessão antes de forçar um reinício, evitando derrubar um canal que na verdade já havia conectado com sucesso.",
      },
      {
        type: "fix",
        text: "Adicionado limite de tentativas consecutivas de reinício automático por canal, evitando loop infinito em ambientes onde o Chrome/Puppeteer não consegue subir.",
      },
      {
        type: "fix",
        text: "Reinício automático de sessão travada agora mata o processo do Chrome de forma mais robusta (PID + subprocessos residuais), eliminando processos órfãos que ficavam consumindo recursos no servidor após falhas de reconexão.",
      },
    ],
  },
  {
    version: "1.19.1",
    date: "2026-07-27",
    title: "Correção de toasts sobrepostos e melhorias de boot",
    highlight: "Correção de conflito visual entre toasts e pequenas melhorias de performance no carregamento inicial.",
    items: [
      {
        type: "improvement",
        text: "Lazy loading das rotas privadas para reduzir o consumo de recursos no boot da aplicação.",
      },
      {
        type: "fix",
        text: "Toasts exibidos simultaneamente (ex: confirmação de login e aviso de notificações do navegador) não disputam mais posição na tela — antes reordenavam continuamente, causando um efeito de piscar.",
      },
      {
        type: "fix",
        text: "Removido reload forçado da página ao detectar token expirado durante a inicialização do socket.",
      },
    ],
  },
  {
    version: "1.19.0",
    date: "2026-07-17",
    title: "Setor padrão de canal, log de acessos negados e correção de tickets duplicados",
    highlight: "Setor padrão de canal com atribuição automática/obrigatória, log de acessos negados a tickets e correção de uma falha que causava criação de tickets duplicados para o mesmo contato.",
    items: [
      {
        type: "new",
        text: "Setor padrão do canal é atribuído automaticamente quando há apenas 1 setor vinculado; passa a ser obrigatório quando há mais de um",
      },
      {
        type: "new",
        text: "Log de tentativas de acesso negado a tickets, para levantamento de ocorrências",
      },
      {
        type: "fix",
        text: "Corrigida condição de corrida que causava criação de múltiplos tickets duplicados para o mesmo contato quando várias mensagens chegavam quase simultaneamente",
      },
    ],
  },
  {
    version: "1.18.0",
    date: "2026-07-16",
    title: "Controle de acesso a tickets por atribuição e perfil supervisor",
    highlight: "- Middleware  valida no backend se o usuário autenticado pode acessar o ticket/mensagem da rota, impedindo acesso a tickets de outros setores apenas trocando o  na URL.",
    items: [
      {
        type: "new",
        text: "Versão 1.18.0 publicada.",
      },
    ],
  },
  {
    version: "1.17.0",
    date: "2026-07-16",
    title: "Controle de acesso por setor, licença remota e melhorias no GLPI",
    highlight: "Perfil de supervisor com controle de acesso por setor, sistema de licença remota, página de controles do sistema e melhorias no atendimento via GLPI, além da correção de falha no processamento de mensagens WhatsApp com JID @lid.",
    items: [
      {
        type: "new",
        text: "Perfil de supervisor com setor por visibilidade e setor padrão por canal",
      },
      {
        type: "new",
        text: "Sistema de licença remota com fallback para variáveis de ambiente",
      },
      {
        type: "new",
        text: "Página de controles do sistema para administração",
      },
      {
        type: "new",
        text: "Filtro de categorias do GLPI por tipo de incidente e visibilidade ao abrir chamado",
      },
      {
        type: "new",
        text: "Preenchimento automático de data/hora de início do atendimento GLPI",
      },
      {
        type: "new",
        text: "Recálculo do tempo trabalhado a partir do início informado manualmente no GLPI",
      },
      {
        type: "improvement",
        text: "Exibição dos campos de tempo trabalhado no atendimento GLPI",
      },
      {
        type: "improvement",
        text: "Preenchimento de data/hora de início ao abrir modal pela lista de atendimentos",
      },
      {
        type: "fix",
        text: "Isolada falha nativa do WhatsApp (chat.serialize()) no processamento de mensagens com JID @lid",
      },
      {
        type: "fix",
        text: "Resolução dinâmica dos IDs de searchoption is_incident/is_helpdesk_visible no GLPI",
      },
      {
        type: "fix",
        text: "Toasts duplicados piscando na interface",
      },
    ],
  },
  {
    version: "1.16.0",
    date: "2026-06-16",
    title: "Integração Meta WABA e monitoramento de sessão",
    highlight: "Integração nativa com WhatsApp Business Cloud API (Meta), monitoramento de sessão WhatsApp e correções de entrega de mensagens via LID.",
    items: [
      {
        type: "new",
        text: "Integração nativa com WhatsApp Business Cloud API (Meta) — gerenciamento de templates, envio de mensagens e ACK em tempo real",
      },
      {
        type: "new",
        text: "Modal de monitoramento de sessão WhatsApp com controles administrativos (reiniciar, forçar QR code)",
      },
      {
        type: "new",
        text: "Janela de conversa WABA de 24h — bloqueio automático de input livre após expiração",
      },
      {
        type: "improvement",
        text: "Seletor de canal ao abrir ticket com tooltip explicativo",
      },
      {
        type: "improvement",
        text: "Preservação de rascunho de mensagem no localStorage por ticket",
      },
      {
        type: "improvement",
        text: "Banner WABA substituído por strip compacto e responsivo",
      },
      {
        type: "fix",
        text: "Resolução de LID ao enviar mensagem para contatos com JID @lid",
      },
      {
        type: "fix",
        text: "Deduplicação de ticket/contato ao receber resposta de JID @lid",
      },
      {
        type: "fix",
        text: "Pipeline de deploy de produção agora executa migrations automaticamente",
      },
      {
        type: "fix",
        text: "Remoção de LevelDB LOCKs e processos Chrome residuais no restart forçado",
      },
    ],
  },
  {
    version: "1.15.1",
    date: "2026-06-11",
    title: "Versão 1.15.1",
    highlight: "- Registro de protocolo enriquecido com dados do fechamento: modo (novo chamado / chamado existente / sem GLPI), categoria, tipo, entidade/cliente, requerente, tempo de serviço, data de serviço e se o chamado foi encerrado",
    items: [
      {
        type: "new",
        text: "Versão 1.15.1 publicada.",
      },
    ],
  },
  {
    version: "1.15.0",
    date: "2026-06-10",
    title: "Documentação interativa, Runbook e CI de releases",
    highlight: "Redesign completo da documentação interna, runbook operacional e pipeline de releases integrado ao GitHub.",
    items: [
      {
        type: "new",
        text: "Modal O que há de novo exibe automaticamente as novidades de cada versão ao fazer login",
      },
      {
        type: "new",
        text: "Manual de Operações (/runbook): 13 runbooks por severidade com diagnóstico, comandos copiáveis e checklist",
      },
      {
        type: "new",
        text: "Guia do Administrador com toggle Atendente/Admin cobrindo todos os módulos do sistema",
      },
      {
        type: "improvement",
        text: "Guia do Sistema redesenhado com accordions, passo a passo ilustrado e mockups inline da interface",
      },
      {
        type: "improvement",
        text: "Pipeline de releases integrado ao GitHub: publicar uma release atualiza o changelog do sistema automaticamente",
      },
    ],
  },
  {
    version: "1.14.0",
    date: "2026-06-10",
    title: "Guia do Sistema redesenhado + Manual de Operações",
    highlight: "Nova documentação interativa com guias separados para atendentes e administradores, e runbook operacional para situações críticas.",
    items: [
      {
        type: "new",
        text: "Guia do Sistema completamente redesenhado com accordions, passo a passo ilustrado e mockups inline dos componentes da interface.",
      },
      {
        type: "new",
        text: "Guia do Administrador com toggle Atendente/Admin: cobre Usuários, Setores, Canais, Configurações (todos os 15 switches explicados), Integrações e Manutenção.",
      },
      {
        type: "new",
        text: "Manual de Operações (/runbook): 13 runbooks por severidade (Crítico, Alto, Médio, Operacional) com diagnóstico, resolução passo a passo, comandos copiáveis e checklist de verificação.",
      },
      {
        type: "improvement",
        text: "Protocolos, Notas e Monitor de Usuários documentados com detalhes de filtros e campos disponíveis.",
      },
    ],
  },
  {
    version: "1.13.0",
    date: "2026-05-20",
    title: "Melhorias no GLPI e canais",
    items: [
      {
        type: "fix",
        text: "Requerente em abertura automática, profiles_id e tipo/categoria obrigatórios no GLPI.",
      },
      {
        type: "fix",
        text: "Criar categoria e classificação na entidade raíz com is_recursive ao conectar GLPI.",
      },
    ],
  },
];
